import md5 from 'blueimp-md5'

//+ client -> string
function labeler(c) {
  let { nom, numero, ville } = c;
  return { label: `${nom} - ${numero} (${ville})`, client: c };
}

//+ -> client
function empty() {
  return {
    nom: "",
    rue: "",
    ville: "",
    numero: "",
    commentaire: "",
    location: null,
    ajout: new Date()
  };
}

function lieu (cli) { return `${cli.rue}, ${cli.ville}, FRANCE` }

//+ client -> boolean
function valid(client) {
    let { nom, numero } = client
    let nomp = nom !== null
        && nom !== undefined
        && nom.length > 0
    let numerop = numero !== null
        && numero !== undefined
        && numero.length === 10
        && Array.from(numero).filter(c => !c.match('[0-9]')).length === 0
    return nomp && numerop
}

function fulladdress (client) { return [client.rue.trim(), client.ville.trim()].join(' ').trim(); }
function gmaps (client) { return `https://maps.google.com/?q=${fulladdress(client)}`; }
function hash (client) { return client.nom + '-' + md5(client.nom); }


export { labeler, empty, valid, fulladdress, gmaps, hash, lieu };
